import React, {Component} from "react";
import {NavLink} from "react-router-dom";
import _ from 'lodash';
import Loading from "./../../loading";
import InmPagination from "./../../widgets/inmPagination";

class GoalsModal extends Component {
	render() {
		const {proigualdad, pages, active, modality, state, municipality, fetching, closeModal} = this.props;
		return <div className={`modal${active ? ' is-active' : ''}`}>
			<div className="modal-background" onClick={() => closeModal()}/>
			<div className="modal-content">
				<div className="message">
					<div className="message-header">
						<p>Metas de la instancia</p>
						<button type="button" onClick={() => closeModal()} className="delete is-medium" aria-label="delete"></button>
					</div>
					<div className="message-body">
						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<NavLink
									to={`/proyecto/${modality}/proigualdad-meta/crear/${state}${municipality ? `/${municipality}` : ''}`}
									className="button is-small is-inm-purple">
									<span className="icon"><i className="fa fa-plus"/></span>
									<span>Agregar Meta</span>
								</NavLink>
							</div>
						</div>
						{fetching ? <Loading message="Cargando..."/> : [
							<table className="table is-fullwidth project-goal-table" key="proigualdad-goals-list-table">
								<thead>
								<tr>
									<th>Código</th>
									<th>Meta</th>
								</tr>
								</thead>
								<tbody>
								{!_.isEmpty(proigualdad) ?
									_.map(proigualdad, (row, k) => {
										return (
											<tr key={k}>
												<td className="goal-cell" style={{width: '10%'}}>
													<strong>{row.code ? row.code : `${row.id}.${row.type}`}</strong>
												</td>
												<td>{row.name}</td>
											</tr>
										)
									}) :
									<tr>
										<td colSpan={2} className="has-text-centered">No hay metas creadas</td>
									</tr>}
								</tbody>
							</table>,

							pages.total > 10 &&
							<InmPagination
								key="concepts-pages"
								current={pages.current}
								total={pages.total}
								perPage={10}
								nextPage={this._handlePageChange}
							/>
						]}
					</div>
				</div>
			</div>
		</div>
	}

	constructor(props) {
		super(props);
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		this.props.pageChange(value);
	}
}

export default GoalsModal;


// WEBPACK FOOTER //
// ./src/elements/project/widgets/project_goals_modal_widget.jsx